<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Campanha:"
    id="selectCampanha"
    placeholder="Selecione a Campanha"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import CampaignRepository from '@/shared/http/repositories/campaign/campaign.js'

export default {
  name: 'NxSelectCampanha',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadCampanhas()
  },
  methods: {
    onLoadCampanhas () {
      CampaignRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.nome, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Assuntos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectCampanha.vue